import { render, staticRenderFns } from "./AssistantHeader.vue?vue&type=template&id=7867cda4"
import script from "./AssistantHeader.vue?vue&type=script&lang=ts"
export * from "./AssistantHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports